// extracted by mini-css-extract-plugin
export default {"arrow":"up_arrow__BipmL","auto":"up_auto__tL2-q","lineUp":"up_lineUp__rn4uD","tipUp":"up_tipUp__3ae3i"};